import React, { ReactNode } from 'react'
import styles from './styles/btn-filter-mobile.module.scss'
import cx from 'classnames'

interface FilterBtnMobileProps {
  onClick?: () => any
  className?: string
  children: ReactNode
}

const BtnFilterMobile = ({ onClick, className, children }: FilterBtnMobileProps) => {
  return (
    <button type='button' className={cx(styles.filterBtnMobile, className)} onClick={onClick}>
      {children}{' '}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        fill='none'
        viewBox='0 0 24 24'
      >
        <path
          stroke='#003A70'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeMiterlimit='10'
          strokeWidth='1.5'
          d='M6.327 9.873h11.345M4.2 5.619h15.6M8.455 14.127h7.09M10.582 18.381h2.836'
        />
      </svg>
    </button>
  )
}

export default BtnFilterMobile
